import { $$ } from '@3pc/dom';
import { Lightbox } from '@3pc/lightbox-photoswipe';

const textmedias = $$('.textmedia');
if (textmedias.length) {
  textmedias.forEach(textmedia => {
    const lightboxToggles = $$('.lightbox-toggle', textmedia);

    if (!lightboxToggles.length) return;

    new Lightbox({
      gallery: textmedia,
      children: lightboxToggles,
    }).init();
  });
}
